import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../../core/Error.js";
import t from "../../../../core/Logger.js";
import { isSome as r } from "../../../../core/maybe.js";
import { e as s } from "../../../../chunks/earcut.js";
import { s as n } from "../../../../chunks/vec2.js";
import { a as o } from "../../../../chunks/vec2f64.js";
import { convertFromNestedArray as c, convertFromPolygon as i } from "../../../../layers/graphics/featureConversionUtils.js";
import a from "../../../../layers/graphics/OptimizedGeometry.js";
import { i1616to32 as f } from "./number.js";
import h from "../../../webgl/BufferObject.js";

var m = t.getLogger("esri.views.2d.engine.webgl.Mesh2D"),
    u = function u(t) {
  switch (t.BYTES_PER_ELEMENT) {
    case 1:
      return 5121;

    case 2:
      return 5123;

    case 4:
      return 5125;

    default:
      throw new e("Cannot get DataType of array");
  }
},
    y = function y(e, t, r, s) {
  var n = 0;

  for (var _o = 1; _o < r; _o++) {
    var _r = e[2 * (t + _o - 1)],
        _s = e[2 * (t + _o - 1) + 1];
    n += (e[2 * (t + _o)] - _r) * (e[2 * (t + _o) + 1] + _s);
  }

  return s ? n > 0 : n < 0;
},
    x = function x(_ref, r) {
  var e = _ref.coords,
      t = _ref.lengths;
  var n = [];

  for (var _o2 = 0, _c = 0; _o2 < t.length; _c += t[_o2], _o2 += 1) {
    var _i = _c,
        _a = [];

    for (; _o2 < t.length - 1 && y(e, _c + t[_o2], t[_o2 + 1], r); _o2 += 1, _c += t[_o2]) {
      _a.push(_c + t[_o2] - _i);
    }

    var _f = e.slice(2 * _i, 2 * (_c + t[_o2])),
        _h = s(_f, _a, 2);

    var _iterator = _createForOfIteratorHelper(_h),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;
        n.push(_e + _i);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return n;
};

var g = /*#__PURE__*/function () {
  function g(e, t, r) {
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

    _classCallCheck(this, g);

    this._cache = {}, this.vertices = e, this.indices = t, this.primitiveType = r, this.isMapSpace = s;
  }

  _createClass(g, [{
    key: "destroy",
    value: function destroy() {
      r(this._cache.indexBuffer) && this._cache.indexBuffer.dispose();

      for (var _e2 in this._cache.vertexBuffers) {
        r(this._cache.vertexBuffers[_e2]) && this._cache.vertexBuffers[_e2].dispose();
      }
    }
  }, {
    key: "elementType",
    get: function get() {
      return u(this.indices);
    }
  }, {
    key: "getIndexBuffer",
    value: function getIndexBuffer(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 35044;
      return this._cache.indexBuffer || (this._cache.indexBuffer = h.createIndex(e, t, this.indices)), this._cache.indexBuffer;
    }
  }, {
    key: "getVertexBuffers",
    value: function getVertexBuffers(e) {
      var _this = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 35044;
      return this._cache.vertexBuffers || (this._cache.vertexBuffers = Object.keys(this.vertices).reduce(function (r, s) {
        return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, s, h.createVertex(e, t, _this.vertices[s])));
      }, {})), this._cache.vertexBuffers;
    }
  }], [{
    key: "fromRect",
    value: function fromRect(_ref2) {
      var e = _ref2.x,
          t = _ref2.y,
          r = _ref2.width,
          s = _ref2.height;
      var n = e,
          o = t,
          c = n + r,
          i = o + s;
      return g.fromScreenExtent({
        xmin: n,
        ymin: o,
        xmax: c,
        ymax: i
      });
    }
  }, {
    key: "fromPath",
    value: function fromPath(e) {
      var t = c(new a(), e.path, !1, !1),
          r = t.coords,
          s = new Uint32Array(x(t, !0)),
          n = new Uint32Array(r.length / 2);

      for (var _o3 = 0; _o3 < n.length; _o3++) {
        n[_o3] = f(Math.floor(r[2 * _o3]), Math.floor(r[2 * _o3 + 1]));
      }

      return new g({
        geometry: n
      }, s, 4);
    }
  }, {
    key: "fromGeometry",
    value: function fromGeometry(t, r) {
      var s = r.geometry.type;

      switch (s) {
        case "polygon":
          return g.fromPolygon(t, r.geometry);

        case "extent":
          return g.fromMapExtent(t, r.geometry);

        default:
          return m.error(new e("mapview-bad-type", "Unable to create a mesh from type ".concat(s), r)), g.fromRect({
            x: 0,
            y: 0,
            width: 1,
            height: 1
          });
      }
    }
  }, {
    key: "fromPolygon",
    value: function fromPolygon(e, t) {
      var r = i(new a(), t, !1, !1),
          s = r.coords,
          c = new Uint32Array(x(r, !1)),
          h = new Uint32Array(s.length / 2),
          m = o(),
          u = o();

      for (var _o4 = 0; _o4 < h.length; _o4++) {
        n(m, s[2 * _o4], s[2 * _o4 + 1]), e.toScreen(u, m), h[_o4] = f(Math.floor(u[0]), Math.floor(u[1]));
      }

      return new g({
        geometry: h
      }, c, 4, !0);
    }
  }, {
    key: "fromScreenExtent",
    value: function fromScreenExtent(_ref3) {
      var e = _ref3.xmin,
          t = _ref3.xmax,
          r = _ref3.ymin,
          s = _ref3.ymax;
      var n = {
        geometry: new Uint32Array([f(e, r), f(t, r), f(e, s), f(e, s), f(t, r), f(t, s)])
      },
          o = new Uint32Array([0, 1, 2, 3, 4, 5]);
      return new g(n, o, 4);
    }
  }, {
    key: "fromMapExtent",
    value: function fromMapExtent(e, t) {
      var _e$toScreen = e.toScreen([0, 0], [t.xmin, t.ymin]),
          _e$toScreen2 = _slicedToArray(_e$toScreen, 2),
          r = _e$toScreen2[0],
          s = _e$toScreen2[1],
          _e$toScreen3 = e.toScreen([0, 0], [t.xmax, t.ymax]),
          _e$toScreen4 = _slicedToArray(_e$toScreen3, 2),
          n = _e$toScreen4[0],
          o = _e$toScreen4[1],
          c = {
        geometry: new Uint32Array([f(r, s), f(n, s), f(r, o), f(r, o), f(n, s), f(n, o)])
      },
          i = new Uint32Array([0, 1, 2, 3, 4, 5]);

      return new g(c, i, 4);
    }
  }]);

  return g;
}();

export { g as default };